import { module } from 'modujs'
import SurveyResultsMixin from '../utils/vue/mixins/SurveyResultsMixin'
import { GtagHandler } from '../app'

export default class SurveyControlResults extends module {

    static get settings() {
        return {
            contentKeys: [ 'levelOne', 'levelTwo', 'levelThree', 'levelFour',]
        }
    }

    constructor(m) {
        super(m)

        // DOM
        this.$el = this.el
    }

    init() {
        var that = this

        this.app = new Vue({
            el: this.$el,
            mixins: [ SurveyResultsMixin ],
            created() {
                this.fetchData('surveyControlResults')

                GtagHandler.emit('surveyCompleteControl')
            },
            computed: {
                results() {
                    return this.rawResults.map(r => ({
                        ...r,
                        answer: Number(r.answer)
                    }))
                },
                totalScore() {
                    return this.results.reduce((acc, obj) =>
                        {
                            return acc + obj.answer * obj.score/10
                        },
                        0
                    )
                },
                level() {
                    if (this.totalScore > 445 || this.results.filter(r => r.answer === 55).length >= 4) {
                        return 3
                    } else if (this.totalScore <= 15 && this.results.findIndex(r => r.answer === 55) < 0) {
                        return 0
                    } else if (this.totalScore <= 130 && this.results.findIndex(r => r.answer === 55) < 0) {
                        return 1
                    } else {
                        return 2
                    }
                },
                contentKey() {
                    return SurveyControlResults.settings.contentKeys[this.level]
                },
                hasViolence() {
                    return this.level > 0
                },
                lsqSrc() {
                    return this.content?.a11yVideo
                },
                // JSON results for SendSurvey Component
                emailContent() {

                    return {
                        level: this.contentKey,
                        results: this.results,
                    }
                },
            },
            methods: {
                toggleWidget() {
                    that.call('toggleWidget', 'WidgetUser')
                    GtagHandler.emit('surveyControlSpeakAssistant')
                },
                nextSurvey() {
                    GtagHandler.emit('startNewSurvey')
                }
            }
        })
    }

    destroy() {
        if (this.app) {
            this.app.$destroy()
        }
    }
}
